module.exports = __webpack_public_path__ + "static/media/info-access-camera-page.59d1a698.svg";